import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Ny restaurant',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Ny demo',
        [CompanyCreationModes.full]: 'Ny restaurant',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Restaurantinfo',
        [CompanyCreationSteps.BusinessInfo]: 'Virksomhedsinfo',
        [CompanyCreationSteps.AdditionalLocations]: 'Yderligere restauranter',
      },
    },
    business_profile: {
      legal_info: 'Juridisk info',
      owner_info: 'Ejerinfo',
    },
    recently_created: 'Nyligt oprettet',
  },
  form: {
    franchise: {
      label: 'Opret restaurant',
      tooltip:
        'Vælg, om du opretter et helt nyt brand eller tilføjer denne restaurant til et eksisterende brand i vores system.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Opret et nyt brand',
          tooltip: 'Vi starter fra bunden – intet eksisterende brand eller restaurant',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Tilføj denne restaurant til et eksisterende brand',
          tooltip: 'Den hører til et brand, der allerede findes i systemet',
        },
      },
    },
    restaurants: {
      label: 'Tilknyttede restaurant(er)',
    },

    business_profile: {
      label: 'Hvem er ejeren?',
      tooltip:
        'Tilhører denne restaurant en ejer/virksomhed, der allerede findes i vores system (f.eks. »Luís Pizza GmbH«)? <br/> Hvis ja, vælg den eksisterende ejer-/virksomhedsprofil. Ellers opret en ny ejer-/virksomhedsprofil.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Opret ny erhvervsprofil for ejer/virksomhed',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Brug eksisterende erhvervsprofil for ejer/virksomhed',
      },
    },
    business_type: {
      label: 'Virksomhedstype',
      placeholder: 'Vælg virksomhedstype',
      options: {
        [BusinessType.Company]: 'Virksomhed',
        [BusinessType.Individual]: 'Enkeltmandsvirksomhed',
      },
    },
    display_name: {
      label: 'Restaurantnavn',
      placeholder: 'Visningsnavn',
    },
    legal_name: {
      label: 'Juridisk navn',
      placeholder: 'Juridisk navn',
    },
    owner_first_name: {
      label: 'Kontaktpersonens fornavn',
      placeholder: 'James',
    },
    owner_last_name: {
      label: 'Kontaktpersonens efternavn',
      placeholder: 'Bond',
    },
    owner_phone_number: {
      label: 'Kontaktpersonens telefonnummer',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Kontaktpersonens e-mail',
      placeholder: 'Indtast e-mail',
    },
    password: {
      label: 'Adgangskode',
      placeholder: 'Indtast adgangskode',
    },

    additional_companies: {
      label: 'Yderligere restauranter under dette brand',
      tooltip:
        'Er der yderligere restauranter under samme brand som {{company}}? <br/> Hvis ja, klik på »Tilføj restaurant« for at tilføje flere lokationer under dette brand. Hvis det er den samme ejer, men et andet brand, skal du ikke tilføje her. Opret det i stedet separat.',
    },
  },
  labels: {
    create_demo: 'Opret demo',
    create_company: 'Opret restaurant',
    business_type: 'Virksomhedstype',
    display_name: 'Visningsnavn',
    legal_name: 'Juridisk navn',
    owner_name: 'Ejerens navn',
    address: 'Adresse',
  },
  fields: {
    name: 'Navn',
    created_at: 'Oprettet',
    actions: 'Handlinger',
  },

  buttons: {
    add_restaurant: '+ Tilføj restaurant',
    continue: 'Fortsæt',
    back: 'Tilbage',
    create: 'Opret restaurant',
    delete: 'Slet',
  },
  popups: {
    delete_demo: {
      title: 'Er du sikker på, at du vil slette?',
    },
  },
  toasts: {
    company_created: 'Restauranten blev oprettet',
    failed_to_create_company: 'Restauranten kunne ikke oprettes',
    failed_to_delete_demo: 'Demoen kunne ikke slettes',
    demo_got_deleted: 'Demoen blev slettet',
    failed_to_load_recently_created_companies: 'De nyligt oprettede restauranter kunne ikke indlæses',
  },
};
